/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 7/7/2023
 */

import React, { useState, useEffect } from "react";
import Select from "react-select";
import api from "../../../base/services/ResApi";
import { FormControl } from "@mui/material";

const AppTypeDropdown = ({
  filterType,
  filterByVal,
  onChange,
  selectRef,
  isRequired,
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    if (filterByVal) {
      let apprvConfig = {
        headers: {
          Action: "V_ALL_APPR_APP",
          "Is-Pagination": "false",
          "Sort-Column": "application_id",
          "Sort-Order": "asc",
          Filter: filterType,
          Value: filterByVal,
          "Is-Req-App-Ids": true,
        },
      }
      const fetchData = () => {
        api
          .get("/applications", apprvConfig)
          .then((res) => {
            setData(res.data?.dataList)
          })
          .catch((error) => {
            console.log(error)
          })
      }
      fetchData()
    }
  }, [filterByVal])

  // Selector
  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "10px",
    }),
  }

  const options = data.map((item) => ({
    value: item.appId,
    label: item.displayName,
    target: { name: "appType", value: item.appId },
  }))

  return (
    <div>
      <p
        style={{
          fontSize: "12px",
          position: "relative",
          top: "-10px",
          left: "10px",
          background: "#fff",
          width: "110px",
          paddingLeft: "5px",
          zIndex: 100,
        }}
      >
        Select App. Type
      </p>
      <FormControl
        sx={{
          minWidth: 300,
          zIndex: 90,
          position: "relative",
          top: "-36px",
          height: 0,
        }}
        size="medium"
      >
        <Select
          required={isRequired}
          ref={selectRef}
          options={options}
          onChange={onChange}
          isClearable
          styles={{
            ...customStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // Ensure it appears above other elements
            }),
          }}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </FormControl>
    </div>
  )
}

export default AppTypeDropdown
